import dispatchEvent from '../utils/dispatch-event.js';
import EVENT from '../enums/event.js';
import STATE from '../enums/state.js';

const classes = {
  hide: 'hidden',
};

class Overlay {
  /**
   * @param {Element} element
   */
  constructor(element) {
    this.overlay = element;

    this.lockScroll = true;

    this.registerEventListeners();
  }

  /**
   * @return {'inactive'|'active'}
   */
  get state() {
    return this.overlay.dataset.state;
  }

  set state(state) {
    this.overlay.dataset.state = state;
  }

  registerEventListeners() {
    this.overlay.addEventListener('click', () => {
      dispatchEvent(EVENT.OVERLAY.DEACTIVATE, this.overlay);
    });

    document.addEventListener(EVENT.OVERLAY.ACTIVATE, event => {
      this.lockScroll = event.detail?.lockScroll;
      this.activate();
    });
    document.addEventListener(EVENT.OVERLAY.DEACTIVATE, () =>
      this.deactivate()
    );
  }

  deactivate() {
    this.overlay.classList.add(classes.hide);

    // Enable scroll on the document
    if (this.lockScroll) {
      document.body.style.removeProperty('height');
      document.body.style.removeProperty('overflow-y');
    }

    this.state = STATE.OVERLAY.INACTIVE;
  }

  activate() {
    this.overlay.classList.remove(classes.hide);

    // Prevent scroll on the document
    if (this.lockScroll) {
      document.body.style.height = '100%';
      document.body.style.overflowY = 'hidden';
    }

    this.state = STATE.OVERLAY.ACTIVE;
  }
}

export default Overlay;
